export default function getAriaLabel(pageNumber: number) {
  return `Перейти на страницу ${pageNumber}`;
}
